export const DISABLE_ANIMATIONS = ['e2e', 'ci'].includes(process.env.OC_ENV);
